function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import cx from "classnames";
var classPrefix = "tc-avatar";
var Avatar = function Avatar(props) {
  var _cx;
  var className = props.className,
    style = props.style,
    size = props.size,
    src = props.src,
    round = props.round,
    border = props.border,
    alt = props.alt,
    errorUrl = props.errorUrl,
    onClick = props.onClick;
  var onError = function onError(ev) {
    ev.target.src = errorUrl;
    ev.target.onerror = null;
  };
  var baseProps = {
    onClick: onClick
  };
  return /*#__PURE__*/React.createElement("img", Object.assign({}, baseProps, {
    style: style,
    className: cx(classPrefix, className, "".concat(classPrefix, "-").concat(size), (_cx = {}, _defineProperty(_cx, "".concat(classPrefix, "-round"), round), _defineProperty(_cx, "".concat(classPrefix, "-border"), border), _cx)),
    src: src || errorUrl,
    alt: alt,
    onError: onError
  }));
};
Avatar.defaultProps = {
  size: 40,
  src: "",
  alt: "",
  border: false,
  round: true,
  errorUrl: "https://photo.8891.com.tw/2022/09/20/1663667373829087.jpg"
};
export default Avatar;